import { Link } from '@twistopayments/design-system/components/atoms/link'

import type { SectionsContactChannelsComponent } from '@twisto/api-cms'

import { Icon, StrapiMedia } from 'homepage/components/atoms'
import { useHighlightedText } from 'homepage/libs/hooks'

import * as styles from './contact-channels.styles'

export const ContactChannels = ({
  title,
  titleHighlight,
  src,
  contacts,
}: SectionsContactChannelsComponent) => {
  const { before, highlight, after } = useHighlightedText(title, titleHighlight)

  return (
    <section css={styles.wrap}>
      {title && (
        <div css={styles.title}>
          {before}
          <span>{highlight}</span>
          {after}
        </div>
      )}

      <div css={styles.box}>
        <ul css={styles.contacts}>
          {contacts?.map((c) => (
            <li key={c.id}>
              <Link css={styles.link} to={c.url}>
                {c.iconName && (
                  <Icon color="primary" name={c.iconName} size="32" />
                )}
                {c.text}
              </Link>
            </li>
          ))}
        </ul>

        {src && <StrapiMedia {...src} css={styles.img} />}
      </div>
    </section>
  )
}
